<template>
  <div id="event-live-curtain">
    <div :class="{'pg-live__live_curtain_img--flame__hide': !isDispCurtain, 'pg-live__live_curtain_img': !isorganizer}">
      <div class='pg-live__live_curtain_organizer-annotation'>
        <template v-if="isDispCurtain && isorganizer">
          <span class="pg-live__live_curtain_label">配信中断中(フィラー表示)</span>
        </template>
      </div>
      <template v-if="isDispCurtain && !isorganizer">
        <img v-bind:src="require('assets/images/live_curtain.png')" class="pg-live__live_curtain_img--flame">
      </template>
    </div>
  </div>
</template>

<script>
  import {db} from '../utils/firebase'
  import firebase from "firebase/app"
  import consts from '../utils/consts'

  export default {
    name: "EventLiveCurtain",
    props: {
      ttsid: { type: String, required: true },
      isorganizer: { type: Boolean, required: true },
      is_fvlive: { type: Boolean, required: true },
    },
    data: () => ({
      isDispCurtainDoc: "",
      isDispCurtain: false,
    }),
    firestore() {
      const firstdoc = "start"
      // 幕のOn/Off
      return {
        isDispCurtainDoc: db.collection(consts.EVENT_LIVE_CURTAIN.PARENT_COLLECTION).doc(this.ttsid).collection(consts.EVENT_LIVE_CURTAIN.CHILD_COLLECTTION).doc(firstdoc)
      }
    },
    mounted: function () {
    },
    methods: {
      // 中断幕表示処理(fvLive以外)
      addCurtainNonFvLive: function(){
        $('.pg-live__stream__iframe').css("visibility", "hidden")
        var targetClass = '.pg-live__stream__iframe'
        var replacedUrl = $('.pg-live__stream__iframe').find('iframe').attr('src').replace('https:','-https:')
        this.switchingLiveStreamNonFvLive(targetClass, replacedUrl)
      },
      // 中断幕非表示処理(fvLive以外)
      removeCurtainNonFvLive: function(){
        $('.pg-live__stream__iframe').css("visibility", "visible")
        var replacedUrl = $('.pg-live__stream__iframe').find('iframe').attr('src').replace('-https:','https:')
        var targetClass = '.pg-live__stream__iframe'
        this.switchingLiveStreamNonFvLive(targetClass, replacedUrl)
      },
      // 動画の表示/非表示処理(fvLive以外)
      switchingLiveStreamNonFvLive: function(targetClass, replacedUrl){
        // 関係者の場合は動画配信状況を切り替えない
        if(!this.isorganizer){
          $(targetClass).find('iframe').attr('src', replacedUrl)
        }
      },
      // 中断幕表示処理(fvLive)
      addCurtainFvLive: function(){
        $('#fvPlayer').css("visibility", "hidden")
        this.switchingLiveStreamFvLive(true)
      },
      // 中断幕非表示処理(fvLive)
      removeCurtainFvLive: function(){
        $('#fvPlayer').css("visibility", "visible")
        this.switchingLiveStreamFvLive(false)
      },
      // 動画の表示/非表示処理(fvLive)
      switchingLiveStreamFvLive: function(isDispCurtain){
        // 関係者の場合は動画配信状況を切り替えない
        if(!this.isorganizer){
          if (isDispCurtain){
            // 中断幕をonにする場合は再生を一時停止
            $('#button_outside_player_pause').click();
          } else {
            // 中断幕をoffにする場合は何もしない
            return;
          }
        }
      },
    },
    watch: {
      // 幕のOn/Offの取得
      isDispCurtainDoc: function () {
        var replacedUrl = ""
        var targetClass = ""
        if(this.isDispCurtainDoc.isClosed){
          this.isDispCurtain = true
          if(!this.isorganizer){
            if(this.is_fvlive){
              this.addCurtainFvLive()
            } else {
              this.addCurtainNonFvLive()
            }
          }
        } else {
          this.isDispCurtain = false
          if(!this.isorganizer){
            if(this.is_fvlive){
              this.removeCurtainFvLive()
            } else {
              this.removeCurtainNonFvLive()
            }
          }
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../packs/application.css';

  .pg-live__live_curtain_img {
    position: absolute;
    width: 0;
    height: 0;
  }

  .pg-live__live_curtain_organizer-annotation {
    display: none;
    position: absolute;
    text-align: right;
    margin-top: 8px;

    @media screen and (max-width: 767px) {
      margin-top: 2px;
    }
  }

  .pg-live__live_curtain_label {
    color: #FFFF00;
    background-color: #000000;
    font-size: 12px;
    padding: 10px 26px 10px 26px;
    margin-top: 20px;

    @media screen and (max-width: 767px) {
      padding: 5px 24px 5px 24px;
    }
  }

  .pg-live__live_curtain_img--flame {
    width: 100%;
    height: 100%;
    background: #fff;
  }

  .pg-live__live_curtain_img--flame__hide {
    display: none;
  }

</style>
